import { render, staticRenderFns } from "./IsFulfillingDialog.vue?vue&type=template&id=2d4fc67e&scoped=true"
import script from "./IsFulfillingDialog.vue?vue&type=script&lang=js"
export * from "./IsFulfillingDialog.vue?vue&type=script&lang=js"
import style0 from "./IsFulfillingDialog.vue?vue&type=style&index=0&id=2d4fc67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4fc67e",
  null
  
)

export default component.exports